import React from 'react'

import { useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { selectIsSocialCampaign } from '@store/campaigns'
import {
  selectIdentitySocialUrl,
  selectIdentityUsername,
  selectInfluencerFullName,
} from '@store/submissions'
import Theme from '@theme'
import { H5, Link } from '@tribegroup'

interface ISubmissionCardHeaderHandleProps {
  campaignId: number
  submissionId: number
  onViewSocial: VoidFunction
}

export const SubmissionCardHeaderHandle: React.FC<ISubmissionCardHeaderHandleProps> = ({
  campaignId,
  submissionId,
  onViewSocial,
}) => {
  const showSocialProfile = useSelector((state: IApplicationState) => selectIsSocialCampaign(state, campaignId))
  const username = useSelector((state: IApplicationState) => selectIdentityUsername(state, submissionId))
  const socialUrl = useSelector((state: IApplicationState) => selectIdentitySocialUrl(state, submissionId))
  const influencerFullName = useSelector((state: IApplicationState) => selectInfluencerFullName(state, submissionId))

  if (showSocialProfile) {
    return (
      <Link href={socialUrl} target="_blank" onClick={onViewSocial}>
        <H5 inline color={Theme.grey900Color}>
          {username}
        </H5>
      </Link>
    )
  }
  return (
    <H5 inline color={Theme.grey900Color}>
      {influencerFullName}
    </H5>
  )
}

export default SubmissionCardHeaderHandle
